import { defineMessages } from 'react-intl';

export default defineMessages({
    requiredMsg: {
        id: 'policy.pa.views.pa-drivers-details.commercial-driver.requiredMsg',
        defaultMessage:
            'All fields below will become required if this driver is listed as a driver on a commercial vehicle',
    },
});
